// /* eslint-disable default-param-last */
// import { SHOW_ORDER_DETAILS, TOGGLE_MODAL } from 'actionTypes/orderDetailsActionTypes';

// const initialState = {
//   status: false,
//   selectedOrder: null,
//   pendingOrders: {
//     showForm: false
//   }
// };

// const orderDetailsReducer = (state = initialState, action) => {
//   // console.log('action', action);
//   switch (action.type) {
//     case SHOW_ORDER_DETAILS:
//       return {
//         ...state,
//         status: action.payload.status,
//         selectedOrder: action.payload.selectedOrder,
//       };
//     case TOGGLE_MODAL:
//       return {
//         ...state,
//         pendingOrders: {
//           showForm: action.payload.showForm
//         }
//       }

//     default:
//       return state;
//   }
// };

// export default orderDetailsReducer;

/* eslint-disable default-param-last */
import {
  SHOW_ORDER_DETAILS,
  TOGGLE_MODAL,
  TOGGLE_ADD_ORDER_MODAL,
} from 'actionTypes/orderDetailsActionTypes';

const initialState = {
  status: false,
  selectedOrder: null,
  pendingOrders: {
    showForm: false,
  },
  showAddOrderForm: false,
};

const orderDetailsReducer = (state = initialState, action) => {
  // console.log('action', action);
  switch (action.type) {
    case SHOW_ORDER_DETAILS:
      return {
        ...state,
        status: action.payload.status,
        selectedOrder: action.payload.selectedOrder,
      };
    case TOGGLE_MODAL:
      return {
        ...state,
        pendingOrders: {
          showForm: action.payload.showForm,
        },
      };
    case TOGGLE_ADD_ORDER_MODAL:
      return {
        ...state,
        showAddOrderForm: action.payload.showAddOrderForm,
      };

    default:
      return state;
  }
};

export default orderDetailsReducer;
